var _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _path5, _path6, _circle5, _circle6, _circle7, _circle8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1046,
    height: 390,
    viewBox: "0 0 1046 390",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 903.879,
    cy: 328.185,
    r: 54.021,
    fill: "white",
    stroke: "black",
    strokeWidth: 14.4056
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 890.345,
    cy: 328.185,
    r: 54.021,
    fill: "black",
    stroke: "white",
    strokeWidth: 14.4056
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.908,
    cy: 328.185,
    r: 54.021,
    fill: "white",
    stroke: "black",
    strokeWidth: 14.4056
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 429.373,
    cy: 328.185,
    r: 54.021,
    fill: "black",
    stroke: "white",
    strokeWidth: 14.4056
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.699 36.4694C245.699 36.4694 245.699 7.6582 274.51 7.6582C303.322 7.6582 922.762 7.6582 965.979 7.6582C1009.2 7.6582 1016.4 50.875 1016.4 50.875L1038.01 176.924C1038.01 176.924 1038.01 289.438 1038.01 302.973C1038.01 331.784 1009.2 331.784 1009.2 331.784C1009.2 331.784 317.727 331.784 281.713 331.784C245.699 331.784 245.699 295.77 245.699 295.77V36.4694Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 14.4056
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.56 62.1508C1004.63 62.3281 1004.67 62.4661 1004.7 62.5589L1004.8 63.0526C1004.89 63.5117 1005.01 64.1874 1005.18 65.0537C1005.51 66.7862 1005.98 69.2805 1006.56 72.3271C1007.71 78.4205 1009.27 86.7219 1010.91 95.5548C1014.19 113.262 1017.75 132.982 1018.95 141.412C1020.17 150.022 1020.35 155.551 1019.34 158.848C1018.89 160.338 1018.26 161.113 1017.56 161.582C1016.81 162.085 1015.55 162.514 1013.36 162.514L850.728 162.514C845.364 162.514 841.316 162.511 838.098 162.245C834.875 161.978 832.901 161.47 831.54 160.715C829.102 159.363 827.445 156.552 825.627 147.406C825.32 145.86 824.975 144.134 824.601 142.257C820.585 122.13 813.131 84.7725 811.36 68.4883C810.446 60.0885 812.189 54.9533 814.906 51.9259C817.632 48.889 821.97 47.2694 827.758 47.2694L982.99 47.2694C991.724 47.2694 997.079 51.1428 1000.34 54.9966C1001.99 56.9573 1003.12 58.9289 1003.82 60.4082C1004.17 61.1441 1004.41 61.7472 1004.56 62.1508Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 7.2028
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 36.4694C8 36.4694 8 7.6582 36.8112 7.6582C65.6224 7.6582 685.063 7.6582 728.28 7.6582C771.496 7.6582 778.699 50.875 778.699 50.875L800.308 176.924C800.308 176.924 800.308 289.438 800.308 302.973C800.308 331.784 771.496 331.784 771.496 331.784C771.496 331.784 80.028 331.784 44.014 331.784C8 331.784 8 295.77 8 295.77V36.4694Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 14.4056
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M667.059 50.8809C641.85 50.8809 641.85 69.5845 641.85 85.0768V141.188C641.85 141.188 641.851 166.126 667.056 166.126H731.885C764.297 166.126 766.428 156.671 764.032 131.552C761.636 106.433 762.729 50.8809 717.479 50.8809H667.059Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 7.2028
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 188.063,
    y: 50.8809,
    width: 136.853,
    height: 115.245,
    rx: 14.4056,
    fill: "white",
    stroke: "black",
    strokeWidth: 7.2028
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.8105,
    y: 50.8809,
    width: 136.853,
    height: 115.245,
    rx: 14.4056,
    fill: "white",
    stroke: "black",
    strokeWidth: 7.2028
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 339.33,
    y: 50.8809,
    width: 136.853,
    height: 115.245,
    rx: 14.4056,
    fill: "white",
    stroke: "black",
    strokeWidth: 7.2028
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 490.583,
    y: 50.8809,
    width: 136.853,
    height: 115.245,
    rx: 14.4056,
    fill: "white",
    stroke: "black",
    strokeWidth: 7.2028
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M836.325 274.168L1023.6 274.168",
    stroke: "white",
    strokeWidth: 14.4056,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0098 230.945L757.087 230.945",
    stroke: "white",
    strokeWidth: 14.4056,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 666.196,
    cy: 328.185,
    r: 54.021,
    fill: "white",
    stroke: "black",
    strokeWidth: 14.4056
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 205.194,
    cy: 328.185,
    r: 54.021,
    fill: "white",
    stroke: "black",
    strokeWidth: 14.4056
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.659,
    cy: 328.185,
    r: 54.021,
    fill: "black",
    stroke: "white",
    strokeWidth: 14.4056
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.675,
    cy: 328.185,
    r: 54.021,
    fill: "black",
    stroke: "white",
    strokeWidth: 14.4056
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.c46aba2374fe31ff188049807830cdc7.svg";
export { ForwardRef as ReactComponent };